import api from 'api'
import { GET_ORDERS_RESERVED } from '../constants'
import { type IGetOrdersReservedResponde } from './types'

export async function getOrdersReserved() {
  return await api.get<IGetOrdersReservedResponde>(GET_ORDERS_RESERVED)
}
